import { cn } from "@/core/helpers/cn";
import { Checkbox } from "@/shared/ui";

type Props = {
  label: string;
  isChecked: boolean;
  onChange: () => void;
  className?: string;
};

export default function OfferCheckbox({ label, isChecked, onChange, className }: Props) {
  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <Checkbox checked={isChecked} onChange={onChange} />
      <button type="button" onClick={onChange} className="text-14 font-medium">
        {label}
      </button>
    </div>
  );
}
